module.exports = __webpack_public_path__ + "img/Slice12-min.feafba2e.png";